import { useAuthStore } from '@/store/modules/auth';
import type { DepartmentTypeEnum, RoleEnum, RoleTypeEnum } from '@/enum';

export function useAuth() {
  const authStore = useAuthStore();
  /**
   * 校验权限
   *
   * @param codes 权限编码
   * @returns
   */
  function hasAuth(codes: string | string[]): boolean {
    if (!authStore.isLogin) {
      return false;
    }
    if (authStore.isStaticSuper) {
      return true;
    }
    if (typeof codes === 'string') {
      return authStore.permissions.includes(codes);
    }

    return codes.some(code => authStore.permissions.includes(code));
  }
  /**
   * 校验角色
   *
   * @param roles 角色编码
   * @returns
   */
  function hasRole(roles: RoleEnum | RoleEnum[]): boolean {
    if (!authStore.isLogin) {
      return false;
    }
    const roleNames = Array.isArray(roles) ? roles : [roles];
    return authStore.userInfo.roles.some(role => roleNames.includes(Number(role) as RoleEnum));
  }
  /**
   * 校验角色类型
   *
   * @param roleTypes 角色类型
   * @returns
   */
  function hasRoleType(roleTypes: RoleTypeEnum | RoleTypeEnum[]): boolean {
    if (!authStore.isLogin) {
      return false;
    }
    const roleTypesArr = Array.isArray(roleTypes) ? roleTypes : [roleTypes];
    return authStore.userInfo.roleList.some(role => roleTypesArr.includes(Number(role.roleType) as RoleTypeEnum));
  }

  /**
   * 校验部门类型
   *
   * @param departmentTypes 部门类型
   * @returns
   */
  function hasDepartmentType(departmentTypes: DepartmentTypeEnum | DepartmentTypeEnum[]): boolean {
    if (!authStore.isLogin) {
      return false;
    }
    const departmentTypesArr = Array.isArray(departmentTypes) ? departmentTypes : [departmentTypes];
    if (authStore.userInfo.department?.departmentType !== undefined) {
      return departmentTypesArr.includes(Number(authStore.userInfo.department?.departmentType) as DepartmentTypeEnum);
    }
    return false;
  }
  /**
   * 校验客户ID是否是当前客户ID
   *
   * @param customerId 客户id
   * @returns
   */
  function isCurrentCustomer(customerId: string): boolean {
    return authStore.userInfo.customer?.id === customerId;
  }

  return {
    hasAuth,
    hasRole,
    hasRoleType,
    hasDepartmentType,
    isCurrentCustomer
  };
}
